import { getPrismic } from "../utils/get-prismic";
import { getNews } from "../utils/get-news";
import { getFeaturedEvents } from "../utils/get-events";
import { Box } from "rebass";
import * as moment from "moment";
import { FeaturedItems } from "../components/featured-items";
import { HR } from "../components/hr";
import { ModuleGrid } from "../components/module-grid";
import { Slice } from "../components/slice";
import { maxWidth } from "styled-system";
import styled from "styled-components";
import t from "typy";

const Home = ({ pageData, newsData, featuredEvents }) => {
  const { body: slices } = pageData.data;
  let { items: news } = newsData;

  // TODO: Make sure we're grabbing the 3 most recent news items
  news = news.slice(0, 3);

  return (
    <Box>
      <Box id="content">
        {slices.map((slice, i) => (
          <Box key={i}>
            {slice.slice_type === "featured_events" && (
              <FeaturedItems
                items={featuredEvents.map(event => {
                  const {
                    start_date,
                    end_date,
                    title,
                    details,
                    excerpt,
                    rsvp,
                    image
                  } = event.data;
                  return {
                    uid: event.uid,
                    image: image,
                    start_date: moment(start_date).format("M.D"),
                    end_date: moment(end_date).format("M.D"),
                    title: title,
                    details: details,
                    excerpt: excerpt,
                    link: {
                      internal: true,
                      href: `/event?uid=${event.uid}`,
                      as: `/events/${event.uid}`
                    },
                    rsvp: rsvp
                  };
                })}
              />
            )}
            {slice.slice_type === "recent_news" && (
              <Box px={[3, 3, 3, 4]} bg="white">
                <HR color="blue.0" />
                <Box py={[4, 4, 4, 6]}>
                  <ModuleGrid
                    title="Centennial News"
                    cta="See all News"
                    link={{ internal: true, href: "/news", as: "/news" }}
                    items={news.map(news_item => {
                      return {
                        ...news_item,
                        image: {
                          url: t(news_item, "default_file['default_file:url']").safeObject,
                          alt: t(news_item, "default_file['default_file:title']").safeObject
                        },
                        link: {
                          internal: true,
                          href: `/news-detail?slug=${news_item.slug}`,
                          as: `/news/${news_item.slug}`
                        }
                      };
                    })}
                  />
                </Box>
              </Box>
            )}
            <Slice slice={slice} idSuffix={i} />
          </Box>
        ))}
        <Box px={[3, 3, 3, 4]}>
          <HR_Wrap mx="auto" maxWidth={3}>
            <HR />
          </HR_Wrap>
        </Box>
      </Box>
    </Box>
  );
};

Home.getInitialProps = async context => {
  const fragment = "document.type";
  const value = "home";
  const options = {
    fetchLinks: [
      "timeline_node.title",
      "timeline_node.image",
      "timeline_node.date",
      "timeline_node.detail_page"
    ]
  };
  const pageData = await getPrismic({ fragment, value, context, options });
  const newsData = await getNews(context);
  const featuredEvents = await getFeaturedEvents({
    context
  });
  return { pageData, newsData, featuredEvents };
};

const HR_Wrap = styled(Box)`
  ${maxWidth}
`;

export default Home;
